/**
 * @typedef {(HTMLElement|HTMLImageElement|HTMLInputElement|HTMLButtonElement)} Node
 */

/**
 * @return {Array<Node>} Array of nodes in DOM
 */
const $Qll = (nodes, parent) => {
  return [...(parent ? parent : document).querySelectorAll(nodes)];
};

/**
 * @return {Node} Node in DOM
 */
const $Q = (node, parent) => {
  return (parent ? parent : document).querySelector(node);
};

export { $Qll, $Q };
